module.exports = __webpack_public_path__ + "static/media/noah.7fc81526.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noah.png
// module id = 101
// module chunks = 0